import { z } from 'zod'

import { USER_ROLE } from '@img-arena/consoles-api-dde'
import { DistributionListRecipientType } from '@/constants/distributionList'

// Docs: https://imgarenahub.atlassian.net/wiki/spaces/5IAS/pages/3594420225/Add+remove+view+email+address
export const DistributionListSportSchema = z.union([
  z.literal('SOCCER'),
  z.literal('BASKETBALL'),
  z.literal('TABLETENNIS'),
  z.literal('VOLLEYBALL'),
  z.literal('VOLLEYBALL-MSFP'),
  z.literal('SNOOKER'),
  z.literal('AMERICAN-FOOTBALL'),
  z.literal('ICE-HOCKEY'),
  z.literal('CRICKET'),
  z.literal('GOLF')
])

const OperatorTypeRecipientSchema = z.object({
  emailAddress: z.string(),
  operatorId: z.number(),
  recipientType: z.literal(USER_ROLE.OPERATOR.toLocaleUpperCase()), // Dont get me started on this... DDE have roles in CamelCase, but they return in this singular endpoint in UPPERCASE
  sports: z.array(DistributionListSportSchema)
})

const AdminTypeRecipientSchema = z.object({
  emailAddress: z.coerce.string().email(),
  recipientType: z.literal(USER_ROLE.ADMIN.toLocaleUpperCase()), // Dont get me started on this... as above
  sports: z.array(DistributionListSportSchema)
})

export const DistributionListRecipientSchema = z.union([
  OperatorTypeRecipientSchema,
  AdminTypeRecipientSchema
])

export const DistributionListSchema = z.array(DistributionListRecipientSchema)

export type DistributionListRecipient = z.infer<typeof DistributionListRecipientSchema>
export type DistributionListSport = z.infer<typeof DistributionListSportSchema>

export const DistributionListAddRecipientSportDataSchema = z.object({
  emailAddress: z.coerce.string().email(),
  sport: DistributionListSportSchema
})

export type DistributionListAddRecipientSportData = z.infer<
  typeof DistributionListAddRecipientSportDataSchema
>

export const DeleteRecipientDataSchema = z.object({
  emailAddress: z.coerce.string().email()
})

export type DistributionListDeleteRecipientData = z.infer<typeof DeleteRecipientDataSchema>

export const DistributionListDeleteRecipientSportDataSchema = z.object({
  emailAddress: z.coerce.string().email(),
  sport: DistributionListSportSchema
})

export type DistributionListDeleteRecipientSportData = z.infer<
  typeof DistributionListDeleteRecipientSportDataSchema
>

export type AddRecipientFormData = {
  emailAddress: string
  recipientType: DistributionListRecipientType
  operatorId: string | null
  sports: DistributionListSport[]
}
